<p-fileupload
  #fileUpload
  [name]="name()"
  [auto]="false"
  [customUpload]="true"
  [showUploadButton]="false"
  [showCancelButton]="false"
  [multiple]="multiple()"
  [accept]="accept()"
  [maxFileSize]="maxFileSize()"
  [disabled]="disabled() || isUploading()"
  (onSelect)="onSelect($event)"
  (onRemove)="onRemove($event)"
  (onClear)="onClear()"
  (onFileError)="onFileTypeError($event)"
  styleClass="custom-fileupload"
  class="w-full"
  [attr.aria-labelledby]="labelId()"
>
  <ng-template pTemplate="header">
    <!-- Nasconde header default per usare il template content custom -->
  </ng-template>

  <ng-template
    pTemplate="content"
    let-files
    let-chooseCallback="chooseCallback"
    let-removeFileCallback="removeFileCallback"
  >
    @if (isUploading()) {
      <div
        class="flex align-items-center justify-content-center gap-2 p-5"
        role="status"
        aria-live="polite"
      >
        <i class="pi pi-spin pi-spinner text-2xl" aria-hidden="true"></i>
        <span class="font-semibold">{{ uploadingLabel() }}</span>
      </div>
    } @else if (!files || files.length === 0) {
      <div class="flex flex-column align-items-center justify-content-center p-5 text-center">
        <i class="pi pi-cloud-upload text-6xl mb-3 text-400" aria-hidden="true"></i>
        <p class="m-0 mb-2 font-semibold text-900">{{ emptyStateTitle() }}</p>
        <p class="m-0 mb-3 text-sm text-600">{{ emptyStateSubtitle() }}</p>
        <p-button
          [label]="chooseLabel()"
          icon="pi pi-folder-open"
          (onClick)="chooseCallback()"
          [outlined]="true"
          [disabled]="disabled()"
          [ariaLabel]="chooseLabel()"
        ></p-button>
      </div>
    } @else {
      <div class="p-3">
        @for (file of files; track file.name) {
          <div
            class="flex align-items-center justify-content-between p-3 border-1 border-200 border-round mb-2"
          >
            <div class="flex align-items-center gap-3">
              <i class="pi pi-file text-3xl text-primary" aria-hidden="true"></i>
              <div>
                <div class="font-semibold text-900">{{ file.name }}</div>
                <small class="text-600">{{ formatFileSize(file.size) }}</small>
              </div>
            </div>
            <p-button
              icon="pi pi-times"
              [rounded]="true"
              [text]="true"
              severity="danger"
              (onClick)="removeFileCallback(file)"
              [disabled]="disabled()"
              [ariaLabel]="'Rimuovi ' + file.name"
            ></p-button>
          </div>
        }
        <p-button
          [label]="replaceLabel()"
          icon="pi pi-folder-open"
          (onClick)="chooseCallback()"
          [outlined]="true"
          size="small"
          class="w-full mt-2"
          [disabled]="disabled()"
          [ariaLabel]="replaceLabel()"
        ></p-button>
      </div>
    }
  </ng-template>
</p-fileupload>

@if (helpText()) {
  <small class="text-600 block mt-2">{{ helpText() }}</small>
}
